import { MarketProductProgress, ProductPlanExtended } from "tm-shared/types";

export const checkIsMML = (
    plan: {
        [barcode: string]: ProductPlanExtended;
    },
    barcode: string,
    isStatisticNotBeforeMotivation: boolean,
    marketFactSales: {
        [barcode: string]: MarketProductProgress;
    },
): boolean => {
    const isMML =
        plan?.[barcode]?.stage === "new_groups" ||
        plan?.[barcode]?.stage === "seed_unseen";

    const productFact = marketFactSales?.[barcode];

    if (isStatisticNotBeforeMotivation) {
        return isMML;
    } else {
        return isMML && (productFact?.bottle === 0 || !productFact);
    }
};
